import { useEffect, useState } from "react";
import { useIsVerified } from "src/components/email-verification";

import {
  MainCard,
  MainCardContent,
  MainCardTitle,
} from "src/components/main-card-type.tsx";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Button } from "src/components/ui/button";
import { removeMask, sanitizeBrlValue } from "src/utils/functions";
import {
  calcularAvisoPrevio,
  CalcularFGTS,
  FormDataProps,
  handleSave,
  RescisaoTrabalhistaResponse,
  schema,
  valoresLocalStorage,
} from "../utils/rescisao.d";

export const RescisaoInputCard = ({
  setResults,
}: {
  setResults: (value: RescisaoTrabalhistaResponse | null) => void;
}) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<FormDataProps>({
    defaultValues: valoresLocalStorage,
    mode: "all",
    criteriaMode: "all",
    resolver: zodResolver(schema),
  });
  const [dataValores, setData] = useState({
    salariobruto: "",
    contrataçao: "",
    demissao: "",
    dependentes: "",
    fgts: "",
    feriasDias: "",
    motivo: "comunAcordo",
    aviso: "valor1",
    tempoRestante: "",
  });
  const [personalizar, setPersonalizar] = useState(false);

  useEffect(() => {
    if (dataValores.motivo === "finalContratoAntes") {
      setPersonalizar(true);
    } else {
      setPersonalizar(false);
    }
  }, [dataValores.motivo]);

  function clear() {
    setData({
      salariobruto: "",
      contrataçao: "",
      demissao: "",
      dependentes: "",
      fgts: "",
      feriasDias: "",
      motivo: "comunAcordo",
      aviso: "valor1",
      tempoRestante: "",
    });
  }

  useEffect(() => {
    setData(valoresLocalStorage);
  }, []);

  const listErros = Object.values(errors);
  const primeiroErro = listErros.find((e) => e.message);

  const handleSubmitForm = (data: FormDataProps) => {
    handleSave(data);
    const ValorBruto = removeMask(data.salariobruto);
    const AnoContratacao = Number(data.contrataçao.split("-")[0]);
    let MesContratacao = Number(data.contrataçao.split("-")[1]);
    const AnoDemitido = Number(data.demissao.split("-")[0]);
    let MesDemitido = Number(data.demissao.split("-")[1]);
    let DiaDemitido = Number(data.demissao.split("-")[2]);
    let valorFgts = CalcularFGTS(
      ValorBruto,
      AnoDemitido,
      MesDemitido,
      AnoContratacao,
      MesContratacao,
    );
    const valorAntigoFGTS = removeMask(data.fgts);
    let saldoSalario: number = (ValorBruto / 30) * DiaDemitido;
    let feriasVencidas: number = ValorBruto + ValorBruto / 3;
    let feriasProporcional: number = 0;
    let decimoProporcional: number = (ValorBruto / 12) * MesDemitido;
    let avisoPrevio: number = 0;
    let fgtsMulta: number = 0;
    let OitentaFgts = valorFgts * 0.8;
    let tempoTrabalhadoAnos = AnoDemitido - AnoContratacao;
    avisoPrevio = calcularAvisoPrevio(tempoTrabalhadoAnos, ValorBruto);

    if (data.aviso === "trabalhado") {
      avisoPrevio = 0;
    }
    if (data.aviso === "naoCumprido") {
      avisoPrevio = -avisoPrevio;
    }

    let valorFinal: number = 0;
    let comFgts: number = 0;

    if (DiaDemitido < 15) {
      MesDemitido--;
    }

    switch (dataValores.motivo) {
      case "pedidoDemissao":
        feriasVencidas = ValorBruto + ValorBruto / 3;
        feriasProporcional = 0;
        comFgts = 0;
        valorFinal =
          saldoSalario + feriasVencidas + decimoProporcional - avisoPrevio;
        break;
      case "dispensaSemcausa":
        feriasProporcional = 0;
        fgtsMulta = valorFgts * 0.4;
        valorFinal =
          saldoSalario +
          feriasVencidas +
          decimoProporcional +
          avisoPrevio +
          valorFgts +
          fgtsMulta;
        comFgts = fgtsMulta;
        break;
      case "dispensaporCausa":
        valorFinal = saldoSalario;
        break;
      case "comunAcordo":
        avisoPrevio = avisoPrevio / 2;
        fgtsMulta = valorFgts * 0.2;
        valorFgts = valorFgts * 0.8;
        valorFinal =
          saldoSalario +
          feriasVencidas +
          decimoProporcional +
          avisoPrevio +
          OitentaFgts +
          fgtsMulta;
        comFgts = fgtsMulta;
        break;
      case "finalContratoDepois":
        MesDemitido = 3;
        feriasProporcional =
          (ValorBruto / 12) * MesDemitido +
          ((ValorBruto / 12) * MesDemitido) / 3;
        valorFinal = saldoSalario + feriasProporcional + decimoProporcional;
        break;
      case "finalContratoAntes":
        saldoSalario = ValorBruto;
        const mesesRestantes = Number(dataValores.tempoRestante);
        let messesTrabalhados = 12 - mesesRestantes;
        decimoProporcional = (ValorBruto / messesTrabalhados) * mesesRestantes;
        feriasProporcional = (ValorBruto / 12) * messesTrabalhados;
        feriasProporcional = feriasProporcional + feriasProporcional / 3;
        const salariosrestantes = ValorBruto * mesesRestantes;
        let metade = salariosrestantes / 2;
        decimoProporcional = (ValorBruto / 12) * mesesRestantes;
        valorFinal =
          saldoSalario +
          decimoProporcional +
          metade +
          feriasProporcional +
          OitentaFgts;
        comFgts = OitentaFgts;
        break;
      case "falecimento":
        valorFinal =
          saldoSalario + feriasVencidas + decimoProporcional + valorFgts;
        comFgts = valorFinal + valorFgts;
        break;
      case "aposentadoria":
        fgtsMulta = valorFgts * 0.4;
        valorFinal =
          saldoSalario +
          feriasVencidas +
          decimoProporcional +
          avisoPrevio +
          valorFgts +
          fgtsMulta;
        comFgts = fgtsMulta;
        break;
    }
    valorFinal = valorFinal + valorAntigoFGTS;
    valorFgts += valorAntigoFGTS;
    comFgts += valorAntigoFGTS;
    valorFinal = Math.round(valorFinal * 100) / 100;
    decimoProporcional = Math.round(decimoProporcional * 100) / 100;
    const results = {
      rescisao: valorFinal,
      multaFGTS: comFgts,
      FGTS: valorFgts,
      saldoSalario: saldoSalario,
      decimoProporcional: decimoProporcional,
      feriasVencidas: feriasVencidas,
      avisoPrevio: avisoPrevio,
    };

    setResults(results);
  };

  const isVerified = useIsVerified();

  return (
    <MainCard>
      <MainCardTitle>Rescisão Trabalhista</MainCardTitle>
      <form onSubmit={handleSubmit(handleSubmitForm)}>
        <MainCardContent>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="meses-id"
            >
              Motivo
            </label>
            <div className="flex border">
              <select
                className="flex-1 p-2 min-w-[100px]"
                id="meses-id"
                {...register("motivo")}
                value={dataValores.motivo}
                onChange={(event) =>
                  setData({
                    ...dataValores,
                    motivo: event.target.value,
                  })
                }
              >
                <option value="comunAcordo"> Demissão de comum acordo</option> 4
                <option value="dispensaSemcausa">
                  Demissão sem justa causa{" "}
                </option>{" "}
                2
                <option value="dispensaporCausa">
                  Demissão com justa causa{" "}
                </option>
                <option value="pedidoDemissao">Pedido de demissão</option>
                <option value="finalContratoDepois">
                  Encerramento no final do contrato de experiência
                </option>{" "}
                5
                <option value="finalContratoAntes">
                  Encerramento antes do prazo
                </option>
                <option value="falecimento">Falecimento </option> *
                <option value="aposentadoria">Aposentadoria</option> *
              </select>
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="bruto-id"
            >
              Salario Bruto
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="00,00"
                type="text"
                {...register("salariobruto")}
                value={dataValores.salariobruto}
                onChange={(event) =>
                  setData({
                    ...dataValores,
                    salariobruto: sanitizeBrlValue(event),
                  })
                }
              />
            </div>
          </div>
          <div className={personalizar ? "hidden" : "block"}>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="meses-id"
            >
              Data de contatação
            </label>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="meses-id"
                placeholder="0"
                value={dataValores.contrataçao}
                type="date"
                {...register("contrataçao")}
                onChange={(event) =>
                  setData({
                    ...dataValores,
                    contrataçao: event.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className={personalizar ? "hidden" : "block"}>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="meses-id"
            >
              Data de demisão
            </label>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="meses-id"
                placeholder="0"
                value={dataValores.demissao}
                type="date"
                {...register("demissao")}
                onChange={(event) =>
                  setData({
                    ...dataValores,
                    demissao: event.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className={personalizar ? "block" : "hidden"}>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="meses-id"
            >
              Tempo que falta para encerrar o contrato
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                Meses
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="meses-id"
                placeholder="0"
                value={dataValores.tempoRestante}
                type="number"
                onChange={(event) =>
                  setData({
                    ...dataValores,
                    tempoRestante: event.target.value,
                  })
                }
              />
            </div>
          </div>

          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="meses-id"
            >
              Aviso prévio
            </label>
            <div className="flex border">
              <select
                className="flex-1 p-2 min-w-[100px]"
                id="meses-id"
                {...register("aviso")}
                value={dataValores.aviso}
                onChange={(event) =>
                  setData({
                    ...dataValores,
                    aviso: event.target.value,
                  })
                }
              >
                <option value="trabalhado">Trabalhando</option>
                <option value="valor2">Indenizado pelo empregador</option>
                <option value="naoCumprido">Não cumprido pelo empregado</option>
                <option value="dispensado">Dispensado</option>
              </select>
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="meses-id"
            >
              Dependentes
            </label>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="meses-id"
                placeholder="0"
                value={dataValores.dependentes}
                type="number"
                {...register("dependentes")}
                onChange={(event) =>
                  setData({
                    ...dataValores,
                    dependentes: event.target.value,
                  })
                }
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="meses-id"
            >
              Saldo FGTS antes da contratação
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="meses-id"
                placeholder="00,00"
                type="text"
                {...register("fgts")}
                value={dataValores.fgts}
                onChange={(event) =>
                  setData({
                    ...dataValores,
                    fgts: sanitizeBrlValue(event),
                  })
                }
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="meses-id"
            >
              Ferias Vencidas
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                Dias
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="meses-id"
                placeholder="0"
                value={dataValores.feriasDias}
                type="number"
                {...register("feriasDias")}
                onChange={(event) =>
                  setData({
                    ...dataValores,
                    feriasDias: event.target.value,
                  })
                }
              />
            </div>
          </div>
        </MainCardContent>
        <div className="flex justify-between">
          <Button
            disabled={!isVerified}
            type="submit"
            variant={"default"}
            className="sm:w-[150px]"
          >
            Calcular
          </Button>
          <div className="flex flex-col sm:flex-row items-center gap-2">
            <Button type="button" onClick={clear} variant={"ghost"}>
              Limpar
            </Button>
          </div>
        </div>
      </form>
      {primeiroErro?.message && (
        <p className="text-red-800 text-center mt-2 font-bold">
          {primeiroErro.message}
        </p>
      )}
    </MainCard>
  );
};
